import { DOM_EVENT, addEventListeners } from '@datadog/browser-core';
export function initFocusObserver(configuration, focusCb) {
    return addEventListeners(configuration, window, [DOM_EVENT.FOCUS, DOM_EVENT.BLUR], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
//# sourceMappingURL=focusObserver.js.map